/** Epoch seconds above this (~year 2050) are treated as permanent brute-force lockout in Keycloak. */
export const FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC = 2_524_656_000;

export function isMerchantRealm(realm) {
  if (!realm) return false;
  return realm.toLowerCase().includes('accounts');
}

export function lockTypeLabel(entry) {
  if (!entry.userEnabled) {
    return 'Permanent (account disabled)';
  }
  const nbf = entry.failedLoginNotBeforeSeconds || 0;
  if (nbf > FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC) {
    return 'Permanent (brute force)';
  }
  if (entry.bruteForceDisabled) {
    const nowSec = Math.floor(Date.now() / 1000);
    if (
      nbf > 0 &&
      nbf <= FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC &&
      nbf > nowSec
    ) {
      return 'Temporary';
    }
    return 'Temporary';
  }
  if ((entry.numFailures || 0) > 0) {
    return 'Failures recorded (not locked)';
  }
  return 'Not restricted';
}

export function unlockCountdownEndEpochSec(entry) {
  if (!entry.userEnabled) {
    return null;
  }
  if (
    (entry.failedLoginNotBeforeSeconds || 0) >
    FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC
  ) {
    return null;
  }
  const nbf = entry.failedLoginNotBeforeSeconds || 0;
  const nowSec = Math.floor(Date.now() / 1000);
  if (nbf > nowSec && nbf <= FAILED_LOGIN_NOT_BEFORE_PERMANENT_THRESHOLD_SEC) {
    return nbf;
  }
  return null;
}

export function formatCountdownFromSeconds(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  }
  return `${m}:${String(sec).padStart(2, '0')}`;
}

export function rowKey(entry) {
  return `${entry.keycloakUserId || 'unknown'}_${entry.realm || ''}`;
}
